import React, { useEffect, useRef, useState } from "react";
import {
  addIconGallery,
  chakMarkWhite,
  checkMarkOrange,
  closeIcon,
  deleteIconBlue,
  deleteIconCircleOrange,
  eyeClose,
  menuDotsIcon,
  modalCloseIcon,
  moveIocn,
  pinIocn,
} from "../../../../../images";
import config from "../../../../../config/config";
import Modal from "react-bootstrap/Modal";
import "./galleryPopupComn.scss";
import FileUpload from "../FileUpload/FileUpload";
import DeleteConfirmPopup from "../DeleteConfirmPopup/DeleteConfirmPopup";
import GalleryPopupRecentlyDeleted from "./GalleryPopupRecentlyDeleted";
import GalleryPopupMove from "./GalleryPopupMove";
import BottomSheetOptions from "./BottomSheetOptions";
import { useWindowSize } from "react-use";

const GalleryEditPopupDefaultV2 = (props) => {
  // const images = [
  //   gallery1,
  //   gallery2,
  //   gallery3,
  //   gallery4,
  //   gallery5,
  //   gallery6,
  //   gallery7,
  //   gallery8,
  //   gallery9,
  //   gallery10,
  //   gallery11,
  //   gallery12,
  //   // "https://images.pexels.com/photos/31214765/pexels-photo-31214765/free-photo-of-dramatic-cliffs-along-the-coast-of-wakayama-japan.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  //   // "https://images.pexels.com/photos/951076/pexels-photo-951076.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  //   // "https://images.pexels.com/photos/951076/pexels-photo-951076.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  //   // "https://images.pexels.com/photos/15568759/pexels-photo-15568759/free-photo-of-bird-among-spring-blossoms-on-tree.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  //   // "https://images.pexels.com/photos/31314773/pexels-photo-31314773/free-photo-of-homemade-baking-in-a-traditional-mexican-kitchen.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  //   // "https://images.pexels.com/photos/31314773/pexels-photo-31314773/free-photo-of-homemade-baking-in-a-traditional-mexican-kitchen.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  //   // "https://images.pexels.com/photos/20257362/pexels-photo-20257362/free-photo-of-back-view-of-a-deer-with-antlers-in-a-forest.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  //   // "https://images.pexels.com/photos/31087915/pexels-photo-31087915/free-photo-of-lush-green-terraced-rice-fields-in-mountainous-landscape.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  //   // gallery1,
  //   // "https://images.pexels.com/photos/31214765/pexels-photo-31214765/free-photo-of-dramatic-cliffs-along-the-coast-of-wakayama-japan.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  //   // gallery3,
  //   // gallery4,
  //   // gallery1,
  //   // gallery7,
  //   // "https://images.pexels.com/photos/31214765/pexels-photo-31214765/free-photo-of-dramatic-cliffs-along-the-coast-of-wakayama-japan.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  //   // "https://images.pexels.com/photos/31214765/pexels-photo-31214765/free-photo-of-dramatic-cliffs-along-the-coast-of-wakayama-japan.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load",
  // ];

  const { width } = useWindowSize();
  const [columns, setColumns] = useState(4); // Default: 4 columns
  const [showFileUploadPopup, setShowFileUploadPopup] = useState(false);
  const [showMovePopup, setShowMovePopup] = useState(false);
  const [arrangedImages, setArrangedImages] = useState([]);
  const [showOptionsPopup, setShowOptionsPopup] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [showDeleteConfirmPopup, setShowDeleteConfirmPopup] = useState(false);
  const [showGallerypopupRecentlyDeleted, setShowGallerypopupRecentlyDeleted] =
    useState(false);
  const [isDeleteMode, setIsDeleteMode] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});
  const aws_object_url = config.aws_object_url;

  const selectedCount = Object.values(checkedItems).filter(Boolean).length;

  const handleCheckboxToggle = (key, item) => {
    setCheckedItems((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  useEffect(() => {
    const updateColumns = () => {
      if (window.innerWidth > 1200) setColumns(4);
      else if (window.innerWidth > 1024) setColumns(4);
      else if (window.innerWidth > 768) setColumns(4);
      else if (window.innerWidth > 340) setColumns(2);
      else setColumns(2);
    };

    updateColumns();
    window.addEventListener("resize", updateColumns);
    return () => window.removeEventListener("resize", updateColumns);
  }, []);

  // Masonry logic: Arranging images row-wise instead of column-wise
  const createMasonryLayout = () => {
    let arranged = Array.from({ length: columns }, () => []);
    let columnHeights = Array(columns).fill(0);
    const filteredImages =
      props?.categoryData?.data?.[props?.categoryData?.category?.key];
    filteredImages?.forEach((img, imgIndex) => {
      const shortestColumnIndex = columnHeights.indexOf(
        Math.min(...columnHeights)
      );
      arranged[shortestColumnIndex].push({
        src: `${aws_object_url}business/${img?.url}`,
        index: imgIndex,
        id: img._id,
      });
      columnHeights[shortestColumnIndex] += 1; // Assuming equal height for each image
    });
    setArrangedImages(arranged);
    return arranged;
  };

  const handleUpdateData = (updatedData) => {
    props.categoryData.data = updatedData;
    createMasonryLayout();
  };

  const [isHovered, setIsHovered] = useState(false);
  const menuRef = useRef(null);
  const handleFileUploadPopupOpen = () => setShowFileUploadPopup(true);
  const handleFileUploadPopupClose = () => {
    setShowFileUploadPopup(false);
  };
  const handleRecentlyDeletedPopupOpen = () =>
    setShowGallerypopupRecentlyDeleted(true);
  const handleRecentlyDeletedPopupClose = () =>
    setShowGallerypopupRecentlyDeleted(false);
  const handleDeleteModeToggle = () => {
    setIsDeleteMode(!isDeleteMode);
    setCheckedItems({});
  };
  const handleDeleteConfirmOpen = () => {
    setShowDeleteConfirmPopup(true);
  };
  const handleDeleteConfirmClose = () => setShowDeleteConfirmPopup(false);
  const handleGallerypopupMoveOpen = () => setShowMovePopup(true);
  const handleGallerypopupMoveClose = () => setShowMovePopup(false);
  const handleOptionsPopupOpen = () => setShowOptionsPopup(true);
  const handleOptionsPopupClose = () => setShowOptionsPopup(false);

  useEffect(() => {
    createMasonryLayout();
  }, [props?.categoryData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsHovered(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {width <= 768 && (
        <BottomSheetOptions
          show={showOptionsPopup}
          handleClose={handleOptionsPopupClose}
          handelOpenDelete={handleDeleteModeToggle}
          handelOpenMove={handleGallerypopupMoveOpen}
          handelOpenRecentlyDeleted={handleRecentlyDeletedPopupOpen}
        />
      )}

      <FileUpload
        show={showFileUploadPopup}
        handleClose={handleFileUploadPopupClose}
        headingSugested={`Add More ${props?.categoryData?.category?.title}`}
        categoryData={props?.categoryData}
        onUpdateData={handleUpdateData}
      />
      <GalleryPopupRecentlyDeleted
        show={showGallerypopupRecentlyDeleted}
        handleCloseDelete={handleRecentlyDeletedPopupClose}
      />
      <DeleteConfirmPopup
        show={showDeleteConfirmPopup}
        handleClose={handleDeleteConfirmClose}
        headingSugested={"Delete Selected Images"}
        selectedCount={selectedCount}
        // data={}
      />
      <GalleryPopupMove
        show={showMovePopup}
        handleCloseDelete={handleGallerypopupMoveClose}
      />
      <Modal
        {...props}
        centered
        className="Gallery_popup_modal gallery_popup_edit"
        backdropClassName="custom-backdrop-gallery-edit"
        fullscreen={true}
      >
        <Modal.Header>
          <button
            className="custom-cancel-btn"
            onClick={isDeleteMode ? handleDeleteModeToggle : props.handleClose}
          >
            <img
              src={modalCloseIcon}
              alt="close-icon"
              className="ctm_img_bussine_edit_about"
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          <h2 className="Gallery_popup_heading d-flex align-items-center">
            {isDeleteMode
              ? "Select Images"
              : `Edit ${props?.categoryData?.category?.title}`}
            {!isDeleteMode && (
              <div
                className="menu-wrapper"
                ref={menuRef}
                onClick={
                  width <= 768
                    ? handleOptionsPopupOpen
                    : () => setIsHovered(!isHovered)
                }
              >
                <div className="three-dot-icon">
                  <img
                    src={menuDotsIcon}
                    alt="menu"
                    className="menu_gallery_popup_edit_icon"
                  />
                </div>
                <div className={`hover-menu ${isHovered ? "show" : "hide"}`}>
                  <div className="menu-item" onClick={handleDeleteModeToggle}>
                    <img
                      src={deleteIconCircleOrange}
                      alt=""
                      className="menu_icon_popup"
                    />
                    Delete Images
                  </div>

                  <div className="menu-item">
                    <img src={eyeClose} alt="" className="menu_icon_popup" />{" "}
                    Hide Images
                  </div>
                  <div className="menu-item">
                    <img src={pinIocn} alt="" className="menu_icon_popup" /> Pin
                    Images
                  </div>

                  <div
                    className="menu-item"
                    onClick={handleGallerypopupMoveOpen}
                  >
                    <img src={moveIocn} alt="" className="menu_icon_popup" />{" "}
                    Move Images
                  </div>
                  <div
                    className="menu-item border-0"
                    onClick={handleRecentlyDeletedPopupOpen}
                  >
                    Recently Deleted
                  </div>
                </div>
              </div>
            )}
          </h2>

          <h3 className="popup_muted_title">
            {isDeleteMode
              ? `${selectedCount} images selected`
              : "Pin up to 5 photos to keep your favorites in the spotlight."}
          </h3>
          <div className="masonry-gallery-two">
            {arrangedImages.map((column, colIndex) => (
              <div className="masonry-column" key={colIndex}>
                {column.map((item, index) => {
                  const itemKey = `${colIndex}-${index}`;
                  const isChecked = checkedItems[itemKey];

                  return (
                    <div
                      className={`masonry-item ${
                        isDeleteMode ? "position-relative" : ""
                      }`}
                      key={itemKey}
                    >
                      <img
                        src={item.src}
                        alt={`Gallery ${index}`}
                        loading="lazy"
                      />

                      {isDeleteMode && (
                        <div
                          onClick={() => handleCheckboxToggle(itemKey, item)}
                          className={`${
                            isChecked
                              ? "checked check_box_ctm_popup_wraper"
                              : "check_box_ctm_popup_wraper"
                          }`}
                        >
                          <input
                            type="checkbox"
                            checked={isChecked || false}
                            onChange={() => {}}
                            className="hiden_ip_ctm_popup"
                          />

                          {isChecked && (
                            <img
                              src={chakMarkWhite}
                              alt="Checkmark"
                              className="chek_mark_ctm_popup"
                            />
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>

          {isDeleteMode ? (
            <div
              className="delete_gallery_image"
              onClick={selectedCount > 0 ? handleDeleteConfirmOpen : null}
            >
              <div className="delete_wrapper">
                <img
                  src={deleteIconBlue}
                  alt="delete"
                  className="delete_icon"
                />
                Delete {selectedCount} Images
              </div>
            </div>
          ) : (
            <div
              className="addMore_gallery_image"
              onClick={handleFileUploadPopupOpen}
            >
              <div className="addMore_wrapper">
                <img
                  src={addIconGallery}
                  alt="add more"
                  className="addMore_icon"
                />
                Add More
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GalleryEditPopupDefaultV2;
